/*
 * Copyright (c) Nexign, JSC, 2020-2022.
 */
/**
 * Saga for getting subscribers regions
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.20.0
 * @since 1.10.0
 */

import { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';

import { IAuthRegion } from '../../pages/PageAuth/types/authTypes';
import { requestSaga } from '../../sagas/requestSaga';
import { stringFormatParams } from '../../utils/stringFormat';
import {
    API_HOSTNAME,
    SUBSCRIBER_MOBILE_REGIONS,
    SUBSCRIBER_MOBILE_REGIONS_BASKET,
    SUBSCRIBER_MOBILE_REGIONS_SUBSCRIBERS,
} from '../app/Api';
import { ESubscribersBasketRegionType, ISubscribersRegionsResponse } from './subscribersTypes';

/**
 * Получить список регионов пользователя
 */
export function* getSubscriberRegionsSaga(): SagaIterator<IAuthRegion[] | undefined> {
    try {
        const URL = `${API_HOSTNAME}${SUBSCRIBER_MOBILE_REGIONS}`;
        const regions: ISubscribersRegionsResponse = yield call(requestSaga, URL, 'GET');
        if (regions.tarificationRegions?.length) {
            return regions.tarificationRegions;
        }
        if (regions.region) {
            return [regions.region]
        }
    } catch (e) {
        throw e;
    }
}

/**
 * Получить список регионов из указанного типа корзины сабсов
 */
export function* getSubscribersBasketRegionsSaga(
    basketType: ESubscribersBasketRegionType,
): SagaIterator<IAuthRegion[] | undefined> {
    try {
        const URL = stringFormatParams(`${API_HOSTNAME}${SUBSCRIBER_MOBILE_REGIONS_BASKET}`, {
            basketType,
        });
        const regions: ISubscribersRegionsResponse = yield call(requestSaga, URL, 'GET');
        if (regions.tarificationRegions?.length) {
            return regions.tarificationRegions;
        }
        if (regions.region) {
            return [regions.region]
        }
    } catch (e) {
        throw e;
    }
}

/**
 * Получить список регионов по списку subsIds
 */
export function* getSubscribersRegionsBiIdsSaga(subsIds: string[]): SagaIterator<IAuthRegion[] | undefined> {
    try {
        const URL = `${API_HOSTNAME}${SUBSCRIBER_MOBILE_REGIONS_SUBSCRIBERS}`;
        const regions: ISubscribersRegionsResponse = yield call(requestSaga, URL, 'POST', subsIds);
        if (regions.tarificationRegions?.length) {
            return regions.tarificationRegions;
        }
        if (regions.region) {
            return [regions.region]
        }
    } catch (e) {
        throw e;
    }
}
